import { Thread } from './thread';
import { PendingPolicy, Role } from './user';

export enum Plan {
  Free = 'Free',
  Professional = 'Professional',
  DFS_INTERNAL = 'DFS',
  CustomForDeepCompareUsage = 'Custom',
  Enterprise = 'Enterprise',
}

export interface Session {
  sub: string;
  email: string;
  roles: Role[];
  threads: Thread[];
  pendingPolicies: PendingPolicy[];
  promptUsage: PromptUsage;
}

export interface PromptUsage {
  plan: Plan;
  perMonth: number;
  usedThisMonth: number;
  remainingThisMonth: number;
}

export const DEFAULT_SESSION: Session = {
  sub: '',
  email: '',
  roles: [],
  threads: [],
  pendingPolicies: [],
  promptUsage: {
    plan: Plan.Free,
    perMonth: 0,
    usedThisMonth: 0,
    remainingThisMonth: 0,
  },
};
